'use client'

import Button from '@/components/form/button'

export default function EnquiryForm() {
  return (
    <form
      action='https://hougarden.us22.list-manage.com/subscribe/post?u=1959320feac7c6607a42cabf2&id=2e31edba61&f_id=008bc2e1f0'
      method='post'
      target='_blank'
      className='flex gap-x-4'
    >
      <input
        type='email'
        name='EMAIL'
        placeholder='Your email address'
        id='mce-EMAIL'
        required
        className='bg-white flex-3 min-w-0 lg:w-87.5 h-12.5 rounded-sm px-4 text-font-primary'
      />
      <input
        type='text'
        aria-hidden='true'
        className='hidden'
        name='b_1959320feac7c6607a42cabf2_2e31edba61'
      />
      <Button
        type='submit'
        bold
        arrow
        className='sm:flex-1 px-3 lg:w-43 text-font-primary whitespace-nowrap'
      >
        Subscribe
      </Button>
    </form>
  )
}
